import React, { useState, useEffect } from 'react'
import { SocialMediaMetricsCard, LeadsCard } from '../../../components'

import NewPaidMediaDashboard from './new_paid_media_dashboard/NewPaidMediaDashboard'
import { handleApi } from '../../../utils/authentication'
import { getPlatformNameOrId } from '../../../helpers/getPlatformName'
import LoadingSpinner from '../../../components/client/LoadingSpinner'
import { useSelector } from 'react-redux'



const PaidMedia = ({ contentRef }) => {

  const [dashboardData, setDashboardData] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const user = useSelector((state) => state?.user)
  const filter = useSelector((state) => state?.filter?.filter_date_range)
  let formData = new FormData();
  formData.append('client_id', user?.client_id)
  if (filter?.days?.value == 'Custom Range') {
    formData.append('start_date', filter?.startDate)
    formData.append('end_date', filter?.endDate)
  } else if (filter?.value) {
    formData.append('days', filter?.value)
  }


  const fetchDashboardData = async () => {
    try {
      setIsLoading(true)
      let result = await handleApi(`get_dashboard_paid_media_metrics`, "POST", {}, formData)
      if (result?.success) {
        setDashboardData(result?.data)
      }



    } catch (e) {
      console.log(e)
    } finally {
      setIsLoading(false)
    }
  }

  let barchart_graph_data = [
    {
      label: 'Google Ads',
      backgroundColor: '#D3A4FF',
      borderColor: '#D3A4FF',
      borderWidth: 1,
      data: [dashboardData?.metrics_data?.clicks, dashboardData?.metrics_data?.impressions, dashboardData?.metrics_data?.spend]
    }
  ]

  const socialMediaData = {
    matrics: [
      {
        name: "Google Ads",
        clicks: dashboardData?.metrics_data?.total_clicks ?? 0,
        impressions: dashboardData?.metrics_data?.total_impressions ?? 0,
        spend: dashboardData?.metrics_data?.total_spend ?? 0,
        selectedPlatform: {
          value: getPlatformNameOrId('Google'),
          label: 'Google Ads'

        },
        border_color: '#FFE58A'
      },
      // {
      //     name: "Lead Generation",
      //     clicks:0,
      //     impressions: 0,
      //     spend: 0,
      //     border_color: '#D3A4FF'
      // },
      // {
      //     name: "Native Ads",
      //     clicks:0,
      //     impressions: 0,
      //     spend: 0,
      //     border_color: '#FFB1E0'
      // },
      {
        name: "OverView",
        clicks: dashboardData?.metrics_data?.total_clicks ?? 0,
        impressions: dashboardData?.metrics_data?.total_impressions ?? 0,
        spend: dashboardData?.metrics_data?.total_spend ?? 0,
        border_color: '#95F3FA'
      }
    ],
    total: {
      clicks: dashboardData?.metrics_data?.total_clicks ?? 0,
      impressions: dashboardData?.metrics_data?.total_impressions ?? 0,
      spend: dashboardData?.metrics_data?.total_spend ?? 0,
      border_color: '#95F3FA'
    }
  }

  useEffect(() => {
    fetchDashboardData()

  }, [filter])



  return (
    <div className='d-flex flex-column gap_lg' ref={contentRef}>
      {isLoading && <LoadingSpinner />}
      {!user?.status && <div className="d-flex justify-content-center align-items-center" >
        <div className="d-flex flex-column gap-2">
          <h5>Your account is Not Active</h5>
          <p>Please contact your administrator</p>
        </div>
      </div>}
      {!isLoading && user?.status &&
        <>
          <SocialMediaMetricsCard socialMediaData={socialMediaData} keys={['Spend', 'Impressions', 'Clicks']} />
          <LeadsCard bar_graph={true}
            pie_chart={false}
            labels={['Clicks', 'Impressions', 'Spend']}
            heading="Clicks / Impressions /  Spend"


            bar_graph_data={barchart_graph_data}

          //  postReactions={postReactions}

          />
          <NewPaidMediaDashboard
            dashboardData={dashboardData}



          /></>}
    </div>
  )
}

export default PaidMedia